<template>
    <div id="wrapper" class="font-fira">
      <TextHeader :headerTitle="$t('gdpr.title')" />
      <div id="content" class="w-container">
        <SectionHeader 
          :text="$t('gdpr.title')" 
          :backText="$t('gdpr.prBackText')" />
        <div>
          <div>
            <h5>Date de contact responsabil cu protecția datelor (D.P.O.)</h5>
            <p><b>Numele și prenumele persoanei desemnate</b>: Ciocan Anamaria</p>
            <p><b>Numărul de telefon</b>: 0746236866</p>
            <p><b>Adresa de e-mail</b>: ciocananamaria@yahoo.com</p>
          </div>
          <div>
            <h5 class="mt-4">Documente utile</h5>
            <p><a href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/gdpr/Politica+CNCM-MC.docx" target="_blank">Informare privind prelucrarea datelor personale la Corul Național de Cameră ”MADRIGAL – Marin Constantin”</a></p>
            <p><a href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/gdpr/Cerere+acces+date+personale.docx" target="_blank">Cerere acces date personale</a></p>
            <p><a href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/gdpr/Cerere+rectificare+date+personale.docx" target="_blank">Cerere rectificare date personale</a></p>
            <p><a href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/gdpr/Cerere+stergere+date+personale.docx" target="_blank">Cerere ștergere date personale</a></p>
          </div>
        </div>        
      </div>
    </div>
  </template>
  
  <script>
  import TextHeader from "../TextHeader";
  import SectionHeader from "../SectionHeader";
  
  export default {
    name: "GDPR",
    components: { SectionHeader, TextHeader },
  };
</script>
  
<style scoped lang="scss"></style>